import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, ValidationErrors, Validators } from "@angular/forms";
import { AuthenticationService } from "app/auth/service";
import { CustomerService } from "app/main/services/customer.service";
import { numberLengthValidator } from "app/main/shared/validators/numberLength.validator";
import { CustomCountryModel, IntlInputPhoneService } from "intl-input-phone";
import { findIndex, intersectionWith, orderBy } from "lodash";
import { combineLatest } from "rxjs";

@Component({
  selector: "input-phone-v2",
  templateUrl: "./input-phone.component.html",
  styleUrls: ["./input-phone.component.scss"],
})
export class InputPhoneV2Component implements OnInit {
  public countries: CustomCountryModel[] = [];
  private multiPrefix = {
    DO: ["1 (809)", "1 (829)", "1 (849)"],
  };

  @Output() valueChanged = new EventEmitter<{
    valid: boolean;
    invalid: boolean;
    value: number;
    errors: ValidationErrors | null;
  }>();

  private company: string;
  country;
  prefix = new FormControl();
  phoneNumber = new FormControl(null, {
    validators: [numberLengthValidator(8, 11)],
  });

  constructor(
    private companyService: CustomerService,
    private authService: AuthenticationService,
    private intlInputPhoneService: IntlInputPhoneService
  ) {}

  ngOnInit(): void {
    this.company = this.authService.companyId;
    this.getRouteCountries();

    combineLatest([
      this.prefix.valueChanges,
      this.phoneNumber.valueChanges,
    ]).subscribe(([prefix, phone]) => {
      const telephone = +`${prefix}${phone}`;
      console.log("Field errors: ", this.phoneNumber.errors);

      this.valueChanged.emit({
        valid: this.phoneNumber.valid,
        invalid: this.phoneNumber.invalid,
        errors: this.phoneNumber.errors,
        value: telephone,
      });
    });
  }

  getRouteCountries = (): void => {
    this.companyService
      .getCompanyCountries(this.company)
      .subscribe((countries: any[]) => {
        this.countries = intersectionWith(
          this.intlInputPhoneService.GetCountryList(),
          countries,
          (a: any, b: any) => a.ISOCode === b.isoCode
        );

        const hn = findIndex(
          this.countries,
          (country) => country.ISOCode.trim() === "HN"
        );
        console.log("HN: ", hn, this.countries);

        this.country = this.countries[hn !== -1 ? hn : 0];
        this.checkMultiPrefix();
      });
  };

  checkMultiPrefix = () => {
    const stackPrefix: CustomCountryModel[] = [];
    this.countries.forEach((item) => {
      const { ISOCode, CountryPhoneCode } = item;
      if (ISOCode in this.multiPrefix) {
        const prefix = this.multiPrefix[ISOCode];
        prefix.forEach((prefix) => {
          if (!CountryPhoneCode.includes(prefix)) {
            stackPrefix.push({
              ...item,
              CountryPhoneCode: prefix,
            });
          }
        });
      }
    });
    this.countries = orderBy(
      this.countries.concat(stackPrefix),
      ["ISOCode"],
      ["asc"]
    );
  };

  select = ($event: CustomCountryModel): void => {
    console.log("Select country: ", $event);
    const prefix = $event.CountryPhoneCode.replace(/\D/g, "");
    this.prefix.setValue(prefix);
  };
}
